//
// Copyright (c) 2021 Astute Global, Inc.
//

import ConversationVariablesModule from "modules/shared/conversationVariables/conversationVariablesModule";
import MarionetteView from "../../marionetteView";
import { uid } from "ckeditor5";
import Messenger from "messaging/messenger";

export default class ConversationVariablesListView extends MarionetteView {
  constructor(locale) {
    super(locale);
    this.set("variableId", null);
    this.set("variableName", null);
    this.namespace = "conversationVariables-" + uid();
  }

  createModule() {
    const module = new ConversationVariablesModule({
      region: this.region,
      namespace: this.namespace,
    });
    this.on("change:variableId", (_evt, _name, newVariableId) => {
      module.setSelected(newVariableId);
    });
    return module;
  }

  focus() {
    if (this.module) {
      this.module.focus();
    }
  }

  setUpVents() {
    Messenger.vent.on(
      Messenger.getFullName("list:item:selected", this.namespace),
      this._onListItemSelected,
      this,
    );
  }

  showModule() {
    this.module.show();
    this.module.setSelected(this.variableId);
  }

  tearDownVents() {
    Messenger.vent.off(
      Messenger.getFullName("list:item:selected", this.namespace),
      this._onListItemSelected,
      this,
    );
  }

  _onListItemSelected(model) {
    this.variableId = model.get("variableId");
    this.variableName = model.get("name");
  }
}
